export const initialComponentErrorValues = {
  student: {},
  parent: {},
  school: {},
  extra: {}
}